(function () {
	'use strict';

	angular.module('mx.components').directive('mxColorPicker', function mxColorPickerDirective() {
		const directive = new mx.components.FormControlBase(MxColorPickerCtrl, 'mx-color-picker/mx-color-picker.html');
		angular.extend(directive.bindToController, {
			legacy: '<',
			onBlur: '&',
		});
		return directive;
	});

	MxColorPickerCtrl.$inject = ['$timeout', '$scope', '$element'];

	function MxColorPickerCtrl($timeout, $scope, $element) {
		var vm = this;
		var colorPickerOpened = false;
		const defaultPickerColor = '#000000';

		vm.isColorPickerSupported = $('<input type="color">')[0].type === 'color';

		var textInputtingColor = '';
		Object.defineProperty(vm, 'textInputtingColor', {
			get: () => textInputtingColor,
			set: setColorModel,
		});

		var mousePickingColor = defaultPickerColor;
		Object.defineProperty(vm, 'mousePickingColor', {
			get: () => mousePickingColor,
			set: setColorModel,
		});

		$scope.$watch('vm.model', function (newValue) {
			if (vm.legacy && typeof newValue === 'string') {
				newValue = newValue.replace(/0xff/i, '#');
			}

			if (newValue !== vm.textInputtingColor) {
				vm.textInputtingColor = newValue;
			}
		});

		vm.$onInit = function () {
			mx.components.FormControlControllerBase.call(vm, $timeout);
			if (vm.legacy) {
				vm._readonly = true;
			}
		};

		vm.$postLink = function () {
			vm.setHintHandlers($element.find('mx-text-box input'));
		};

		vm.blurText = blurText;
		vm.focusColor = focusColor;
		vm.onColorPickerClick = onColorPickerClick;
		vm.setColorModel = setColorModel;

		return vm;

		function setColorModel(color) {
			textInputtingColor = color;
			if (isValidColor(color)) {
				mousePickingColor = color;
				if (vm.legacy && typeof color === 'string') {
					color = color.replace('#', '0xFF');
				}
				if (vm.model !== color) {
					vm.model = color;
				}
			} else if (color === null || (typeof color === 'string' && color.trim() === '')) {
				mousePickingColor = defaultPickerColor;
				vm.model = null;
			}
		}

		function isValidColor(color) {
			return /^#[\da-f]{6}$/i.test(color);
		}

		function blurText() {
			$timeout(function () {
				if (!colorPickerOpened) {
					vm.onBlur();
				}
			}, 200);
		}

		function focusColor() {
			if (colorPickerOpened) {
				colorPickerOpened = false;
				$timeout(function () {
					vm.onBlur();
				}, 100);
			}
		}

		function onColorPickerClick() {
			colorPickerOpened = true;
		}
	}
})();
